import React, { Fragment } from "react";
import { Dialog } from "primereact/dialog";
import { useState } from "react";

export const HomeInfoModal = ({ title, description, children }) => {
  const [visible, setVisible] = useState(false);

  const onModalClose = () => setVisible(false);
  const onModalOpen = () => setVisible(true);

  return (
    <Fragment>
      <Dialog
        header={title}
        visible={visible}
        onHide={onModalClose}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      >
        <div className="flex flex-column">{children}</div>
      </Dialog>

      <div
        onClick={onModalOpen}
        className="p-3 border-round flex align-items-center justify-content-between cursor-pointer"
        style={{ background: "#EBEBEB", borderBottom: "1px solid #c5c5c5" }}
      >
        <div>
          <h3>{title}</h3>
          <p className="font-normal">{description}</p>
        </div>
        <i className="pi pi-chevron-right ml-4"></i>
      </div>
    </Fragment>
  );
};
